import Rating from "@mui/material/Rating";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { markConsultationComplete, placeReview } from "../../api/index";
import { useDispatch, useSelector } from "react-redux";

import "./Review.css";

function Review({ match, history }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  console.log(user);

  const [rating, setRating] = useState(0);
  const [name, setName] = useState(
    user?.patient?.firstName + " " + user?.patient?.lastName
  );
  const [email, setEmail] = useState(user?.patient?.email);
  const [message, setMessage] = useState("");

  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const valid = validation();
    if (valid > 0) return;

    // dispatch(login(data));
    const newReview = await placeReview({
      name,
      email,
      rating,
      message,
      consultationId: match.params.id,
    });
    // const updateConsultation = await markConsultationComplete(match.params.id);
    if (newReview) {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Success! Your review has been saved",
        text: "Thank your for your review",
        showConfirmButton: false,
        timer: 2000,
      }).then(() => {
        history.push("/dashboard");
      });
    }
  };

  const validation = () => {
    let errors = {};
    if (!name) errors.name = "Name is required";
    if (!email || !/^\S+@\S+\.\S+$/.test(email))
      errors.email = "Email is required";
    if (!message) errors.message = "Message is required";
    if (rating === 0) errors.rating = "Rating is required";

    setErrors(errors);
    return Object.keys(errors).length;
  };

  return (
    <div className="signinpage">
      <div className="doctor_div">
        <div className="doctor_img">
          <img src="/img/ladydoctor.jpg"></img>
        </div>
      </div>

      <div className="sign_in_page">
        <div className="white_back">
          <div className="sign_logo">
            <Link to={"/"}>
              <img src="/img/logo1.png"></img>
            </Link>
          </div>
          <p className="signin_heading">Place Review</p>
          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <div className="input_sign_div">
              <div className="input_1">
                <img alt={"mail"} src="/img/mail.svg" />
                <input
                  name="name"
                  className={errors.name ? "sign_input_error" : "sign_input"}
                  placeholder="Your Name"
                  defaultValue={
                    user?.patient?.firstName + " " + user?.patient?.lastName
                  }
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="input_1">
                <img alt={"mail"} src="/img/mail.svg" />
                <input
                  name="email"
                  className={errors.email ? "sign_input_error" : "sign_input"}
                  placeholder="Email"
                  defaultValue={user?.patient?.email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="input_1">
                <img alt={"mail"} src="/img/mail.svg" />
                <textarea
                  name="message"
                  className={errors.message ? "sign_input_error" : "sign_input"}
                  placeholder="Message"
                  rows={5}
                  style={{ height: "100px" }}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
              </div>
              <div className="input_1">
                <Rating
                  name="simple-controlled"
                  value={rating}
                  size="large"
                  onChange={(event, newValue) => {
                    setRating(newValue);
                  }}
                />
                {errors?.rating && (
                  <p style={{ color: "red", fontSize: "13px" }}>
                    {errors?.rating}
                  </p>
                )}
              </div>

              <div className="sign_menu">
                <button type="submit" className="themebutton_end">
                  Place Review
                </button>
                <a>
                  <div className="img_wrap_end">
                    <img src="/img/chevron-right.svg" />
                  </div>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Review;
